import React, { useEffect } from 'react';
import { useIntl } from '@@/plugin-locale/localeExports';
import { MoBaseContainer as BaseContainer } from '@gov-mo/components';
import clsx from 'clsx';
import styles from './css/FosterAppnote.module.less';

const Faceauthb: React.FC = () => {
  const intl = useIntl();
  // 獲取參數
  const urlParams = new URLSearchParams(window.location.search);
  const index = urlParams.get('index');
  // 請求數據
  useEffect(() => {

  }, []);

  // 定義標題映射
  const titleMap: Record<string, string> = {
    '1': intl.formatMessage({ id: '服務簡介' }),
    '2': intl.formatMessage({ id: '申請對象' }),
    '3': intl.formatMessage({ id: '內容' }),
    '4': intl.formatMessage({ id: '申請條件' }),
    '5': intl.formatMessage({ id: '申請流程' }),
    '6': intl.formatMessage({ id: '聯絡資料' }),
  };
  // 根據 index 動態獲取標題
  const dynamicTitle = titleMap[index || ''] || '申請成為寄養父母';
  return (
    <div className={styles.baseRoot}>
      <BaseContainer
        type="custom"
        bodyContentClass={styles.bodyContent}
        titleContent={dynamicTitle}
      >
        <div className={styles.root}>
          <div className={styles.main}>
            {index === '1' && (
              <div className={clsx(styles.paragr)}>
                {/* <p className={clsx(styles.paragrTitle)}>{intl.formatMessage({ id: '寄養服務是什麼？' })}</p> */}
                {/* eslint-disable-next-line max-len */}
                <p className={clsx(styles.paragrContent)}>{intl.formatMessage({ id: '寄養服務是一項兒童住宿服務，旨在安排有需要的兒童入住寄養家庭，讓兒童在寄養家庭裏，繼續享受家庭般的呵護及關懷，直至他們能與家人團聚，或獲得其他維護兒童最佳利益及成長發展所需的安排。' })}</p>

              </div>
            )}
            {index === '2' && (
              <div className={clsx(styles.paragr)}>
                <p className={clsx(styles.paragrTitle)}>{intl.formatMessage({ id: '現誠邀有愛心、有熱心的父母們加入寄養父母的行列' })}</p>
                {/* <p className={clsx(styles.paragrTitle)}>{intl.formatMessage({ id: '對象' })}</p> */}
                {/* eslint-disable-next-line max-len */}
                <p className={clsx(styles.paragrContent)}>{intl.formatMessage({ id: '經本局評估符合資格，年齡介乎於25-65歲，結婚逾3年或以上，居澳年期超過5年且持有澳門居民身份證及符合其他規定條件(參閱以下成為寄養父母的基本條件)的夫婦可提出申請。' })}</p>
              </div>
            )}
            {index === '3' && (
              <div className={clsx(styles.paragr)}>
                {/* <p className={clsx(styles.paragrTitle)}>{intl.formatMessage({ id: '內容' })}</p> */}
                <p className={clsx(styles.paragrContent)}>{intl.formatMessage({ id: '為3-18歲有需要的兒童提供暫時性的家庭式照顧服務。' })}</p>
              </div>
            )}
            {index === '4' && (
              <div className={clsx(styles.paragr)}>
                {/* <p className={clsx(styles.paragrTitle)}>{intl.formatMessage({ id: '成為寄養父母的基本條件' })}</p> */}
                <p className={clsx(styles.paragrContentSpan)}>
                    {intl.formatMessage({ id: '居澳年期超過5年或以上且持有澳門居民身份證' })}
                </p>
                <p className={clsx(styles.paragrContentSpan)}>
                  {intl.formatMessage({ id: '年齡介乎於25至65歲之間' })}
                </p>
                <p className={clsx(styles.paragrContentSpan)}>
                  {intl.formatMessage({ id: '夫婦已辦理結婚登記逾3年或以上' })}
                </p>
                <p className={clsx(styles.paragrContentSpan)}>
                  {intl.formatMessage({ id: '無刑事犯罪紀錄' })}
                </p>
                <p className={clsx(styles.paragrContentSpan)}>
                  {intl.formatMessage({ id: '需具小學畢業程度或以上' })}
                </p>
                <p className={clsx(styles.paragrContentSpan)}>
                  {intl.formatMessage({ id: '家庭經濟狀況穩定，有獨立的生計來源維持家庭成員的日常生活' })}
                </p>
                <p className={clsx(styles.paragrContentSpan)}>
                  {/* eslint-disable-next-line max-len */}
                  {intl.formatMessage({ id: '夫婦任一方要有固定的工作及收入，另一人為全職的家庭照顧者或可在兒童上學時及兒童正常不在家的情況下從事每星期不多於25小時的兼職；又或為雙職的夫婦，但經評估具有足夠而合適照顧支援的家庭' })}
                </p>
                <p className={clsx(styles.paragrContentSpan)}>
                  {intl.formatMessage({ id: '喜愛兒童及有照顧兒童的經驗和能力' })}
                </p>
                <p className={clsx(styles.paragrContentSpan)}>
                  {intl.formatMessage({ id: '能為兒童提供整潔、安全的居住環境' })}
                </p>
                <p className={clsx(styles.paragrContentSpan)}>
                  {intl.formatMessage({ id: '樂意與社工及寄養兒童的家人合作' })}
                </p>
                <p className={clsx(styles.paragrContentSpan)}>
                  {intl.formatMessage({ id: '健康良好，無傳染性疾病' })}
                </p>
              </div>
            )}
            {index === '5' && (
              <div className={clsx(styles.paragr)}>
                {/* <p className={clsx(styles.paragrTitle)}>{intl.formatMessage({ id: '成為寄養父母的流程' })}</p> */}
                <p className={clsx(styles.paragrContentSpan)}>{intl.formatMessage({ id: '1.電話查詢/填寫申請資料' })}</p>
                <p className={clsx(styles.paragrContentSpan)}>{intl.formatMessage({ id: '2.接受電話甄選' })}</p>
                <p className={clsx(styles.paragrContentSpan)}>{intl.formatMessage({ id: '3.出席座談會' })}</p>
                <p className={clsx(styles.paragrContentSpan)}>{intl.formatMessage({ id: '4.呈交申請表' })}</p>
                <p className={clsx(styles.paragrContentSpan)}>{intl.formatMessage({ id: '5.家庭評估' })}</p>
                <p className={clsx(styles.paragrContentSpan)}>{intl.formatMessage({ id: '6.培訓' })}</p>
                <p className={clsx(styles.paragrContentSpan)}>{intl.formatMessage({ id: '7.寄養父母名冊' })}</p>
                <p className={clsx(styles.paragrContentSpan)}>{intl.formatMessage({ id: '8.配對兒童入住寄養家庭' })}</p>
                {/* eslint-disable-next-line max-len */}
                <p className={clsx(styles.paragrContent)}>{intl.formatMessage({ id: '填寫申請資料並經過社會工作局的電話甄選後符合基本條件的夫婦，本局將透過電話邀請出席座談會，座談會中工作員將詳盡介紹有關服務内容，以讓有興趣的夫婦決定是否申請參與有關服務。' })}</p>
              </div>
            )}
            {index === '6' && (
              <div className={clsx(styles.paragr)}>
                {/* eslint-disable-next-line max-len */}
                {/* <p className={clsx(styles.paragrContent)}>{intl.formatMessage({ id: '遞交回條並經過社會工作局的電話甄選後符合基本條件的夫婦，本局將透過電話邀請出席座談會，座谈會中工作員將詳毒介紹有關服務内容，以讓有興趣的夫婦决定是否申請參與有關服務。' })}</p> */}
                <p className={clsx(styles.paragrTitle)}>{intl.formatMessage({ id: '查詢致電︰83997703/83997766' })}</p>
              </div>
            )}
          </div>
        </div>
      </BaseContainer>
    </div>
  );
};

export default Faceauthb;
